import { useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import { AspirationsToday } from '@/rtk-query.gql';
import { useSites } from '@/services/sites';
import { AspirationSite } from '@/types.gql';
import { formatDateWithPattern } from '@/utils';

import * as OpuSearch from './OpuSearchRoot';
import { useCompletedAspirations } from './hooks/useCompletedAspirations';
import { initialState } from './utils/state';

import './OpuSearch.css';

export const OpuSearchPage = ({ className = '' }: { className?: string }) => {
  const [params] = useSearchParams();
  const [showForm, setShowForm] = useState(initialState.showForm);
  const [originalTimeZone, setOriginalTimeZone] = useState<string | null>(null);

  const opuDate =
    params.get('date') ?? formatDateWithPattern(new Date(), 'MM-dd-yyyy');
  const opuSiteId = params.get('site');
  const location = params.get('location');
  const aspirationId = params.get('id');

  const { data: aspirations, refetch } = useCompletedAspirations({
    date: opuDate,
    siteId: opuSiteId,
    location,
  });

  const { data: siteData } = useSites({ filter: 'aspiration' });
  const poolNumArray = aspirations
    .filter((a) => a.poolNum != null)
    .map((a) => Number(a.poolNum));

  if (!aspirationId && showForm) setShowForm(false);

  return (
    <OpuSearch.Root className={`${className}`.trim()}>
      {showForm ? (
        <div className="max-w-screen-2xl p-2">
          <OpuSearch.Form
            setShowForm={setShowForm}
            refetch={refetch}
            poolNumArray={poolNumArray}
            originalTimeZone={originalTimeZone}
            setOriginalTimeZone={setOriginalTimeZone}
          />
        </div>
      ) : (
        <>
          <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
            <OpuSearch.Selector siteData={siteData as AspirationSite[]} />
            <OpuSearch.Actions
              refetch={refetch}
              siteData={siteData as AspirationSite[]}
              aspirations={aspirations as AspirationsToday[]}
              poolNumArray={poolNumArray}
            />
          </div>

          <OpuSearch.Grid
            className="form"
            setShowForm={setShowForm}
            aspirations={aspirations as AspirationsToday[]}
            originalTimeZone={originalTimeZone}
            setOriginalTimeZone={setOriginalTimeZone}
          />
        </>
      )}
    </OpuSearch.Root>
  );
};
